export default {
    Get: {
        KANBAN_URL: 'getKanbanUrl',
        KANBAN_AUTHENTICATION: 'getKanbanAuthentication',
    },
    Set: {
        KANBAN_URL: 'setKanbanUrl',
        KANBAN_AUTHENTICATION: 'setKanbanAuthentication',
    }
};